export const appVersion = 'aaa1344229-53285';
